import { flow } from 'lodash';
import { addDays, addMonths, isBefore } from 'date-fns';
import { getSecondTuesday } from './getSecondTuesday';

/**
 * Get the day after the current patch tuesday
 */
export const getDayAfterPreviousUpdateTuesday = () =>
  flow(
    getSecondTuesday,
    thisPatchTuesday => {
      if (isBefore(Date.now(), thisPatchTuesday)) {
        return addMonths(thisPatchTuesday, -2);
      } else {
        return addMonths(thisPatchTuesday, -1);
      }
    },
    thisPatchTuesday => addDays(getSecondTuesday(thisPatchTuesday), 1) //the day after tuesday
  )(new Date());
